export default __webpack_public_path__ + "locales/ko-KR/VersionHistory.json?hash=d8be2ac010e1a982f2a2b0ae65b31ba0";